export default __webpack_public_path__ + "3712822c7280c7ddae4c2457d3fb181e.png";